export default __webpack_public_path__ + "static/media/write-own-prompt.7ac125a5.svg";